module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"more":"Rodyti daugiau"}}')
  delete Component.options._Ctor
}
